import React from "react";
import { Radio, Form, Space } from "antd";
import { SourcingType } from "../interface";

interface TypeSelectorProps {
  value?: SourcingType;
  onChange?: (value: SourcingType) => void;
}

export const TypeSelector: React.FC<TypeSelectorProps> = ({ value, onChange }) => {
  return (
    <Form.Item
      label="Sourcing Type"
      rules={[{ required: true, message: "Please select sourcing type" }]}
    >
      <Radio.Group value={value} onChange={(e) => onChange?.(e.target.value)}>
        <Space direction="vertical">
          <Radio value={SourcingType.RFQ}>
            <Space direction="vertical" size={0}>
              <div style={{ fontWeight: 500 }}>RFQ - Request for Quotation</div>
              <div style={{ fontSize: '12px', color: '#666' }}>
                Request suppliers to provide pricing for specific items
              </div>
            </Space>
          </Radio>
          <Radio value={SourcingType.RFP}>
            <Space direction="vertical" size={0}>
              <div style={{ fontWeight: 500 }}>RFP - Request for Proposal</div>
              <div style={{ fontSize: '12px', color: '#666' }}>
                Request detailed proposals including technical specifications and solutions
              </div>
            </Space>
          </Radio>
        </Space>
      </Radio.Group>
    </Form.Item>
  );
};